export default __webpack_public_path__ + "static/media/bg-blue-abs5.ad28e25f.jpg";